import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { InputText } from "primereact/inputtext";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import {
  editarMarca,
  guardarMarca,
} from "../../../../../../API/IT/Dispositivos/DispositivosRequest";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";

const MarcasCRUD = ({
  listMarcas,
  showDialog,
  marca,
  setShowDialog,
  getInfo,
}) => {
  const { userAuth } = useContext(AuthContext);
  const toastDialog = useRef(null);

  const [loading, setLoading] = useState(false);

  const initialValues = {
    IdMarca: -1,
    Marca: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    setValues({
      ...marca,
      IdMarca: marca?.IdMarca,
      Marca: marca?.Marca,
    });

    setLoading(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Marca) {
      error.Marca = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const verificarDuplicado = () => {
    const duplicado = listMarcas.find(
      (r) => r.IdMarca !== values.IdMarca && r.Marca === values?.Marca
    );

    if (duplicado) {
      let mensaje = "Ya existe una marca con el mismo valor de: ";
      if (duplicado.Marca === values.Marca) mensaje += `${duplicado.Marca} `;
      return mensaje;
    }

    return null;
  };

  const agregarMarca = async () => {
    const e = verificarInfo();

    if (!e.error) {
      const duplicado = verificarDuplicado();

      if (duplicado) {
        toastShow(toastDialog, "error", "Error", duplicado);
        return;
      }

      const a = {
        IdMarca: values?.IdMarca,
        Marca: values?.Marca,
        IdUserCreated: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      };

      setLoading(true);

      if (a.IdMarca > 0) {
        const resultado = await editarMarca(a);
        toastShow(
          toastDialog,
          "success",
          "Datos Editados",
          "Marca Edita Correctamente"
        );
        getInfo();
        setTimeout(() => {
          onHide();
          setLoading(false);
        }, 1300);
      } else {
        const resultado = await guardarMarca(a);
        toastShow(
          toastDialog,
          "success",
          "Datos Agregados",
          "Marca Agregada Correctamente"
        );
        getInfo();
        setTimeout(() => {
          onHide();
          setLoading(false);
        }, 1300);
      }
      setLoading(false);
    }
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setError({});
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={marca?.IdMarca > 0 ? "Editar" : "Agregar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregarMarca();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = marca?.IdMarca > 0 ? "Editar Marca" : "Agregar Marca";

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor1"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: "35%" }}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ margin: "auto" }}>
            <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor">
              <div className="field col-12">
                <span className="p-float-label">
                  <InputText
                    name="Marca"
                    value={values?.Marca}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Marca ? "p-invalid" : ""}
                  />
                  <label htmlFor="Marca">Marca</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default MarcasCRUD;
